/*
 *
 * Company reducer
 *
 */

import { fromJS } from 'immutable'

import {
  GET_COMPANY_DATA,
  GET_COMPANY_DATA_SUCCESS,
  GET_COMPANY_DATA_FAILED,
} from './constants'

const initialState = fromJS({
  error: false,
  loading: false,
})

function companyReducer(state = initialState, action) {
  switch (action.type) {
    case GET_COMPANY_DATA:
      return state.set('loading', true).set('error', false)

    case GET_COMPANY_DATA_SUCCESS:
      return state
        .set('companyCode', action.companyCode)
        .set('error', false)
        .set('loading', false)

    case GET_COMPANY_DATA_FAILED:
      return state.set('loading', false).set('error', action.error)

    default:
      return state
  }
}

export default companyReducer
